import type { ExerciseRendererFn } from "./types.js";
import { SolfegeRenderer } from "./SolfegeRenderer.js";
import { DictationRenderer } from "./DictationRenderer.js";
import { RhythmicRenderer } from "./RhythmicRenderer.js";
import { MultipleChoiceRenderer } from "./MultipleChoiceRenderer.js";
import { FretboardRenderer } from "./FretboardRenderer.js";

const EXACT: ReadonlyMap<string, ExerciseRendererFn> = new Map([
  ["scale-degree-recognition", SolfegeRenderer],
  ["melodic-dictation",        DictationRenderer],
  ["rhythmic-dictation",       RhythmicRenderer],
]);

const PREFIX: ReadonlyArray<[string, ExerciseRendererFn]> = [
  ["fret-", FretboardRenderer],
];

const FALLBACK: ExerciseRendererFn = MultipleChoiceRenderer;

export function getRenderer(exerciseType: string): ExerciseRendererFn {
  return (
    EXACT.get(exerciseType) ??
    PREFIX.find(([p]) => exerciseType.startsWith(p))?.[1] ??
    FALLBACK
  );
}
